import {
  LegacyProductCode,
  ProductBehavior,
} from '@up2stay/up2promo-api-client';

/** Sentinel for missing identity fields in facet filters (matches backend). */
export const UNKNOWN_FACET_VALUE = '__unknown__';

export type BehaviourLabelKey =
  | 'typeUrl'
  | 'typeProfile'
  | 'typeBusinessCard'
  | 'typeGoogleReview'
  | 'typeInstagram'
  | 'typeFacebook'
  | 'typeTiktok'
  | 'typeMenu';

/** Behaviour / product kind labels, keyed like the app's `products.edit` dictionary. */
export type ProductKindLabels = Partial<Record<BehaviourLabelKey, string>>;

/** Intended behaviour long values for Products list filters (ADR-0014). */
export const INTENDED_BEHAVIOR_OPTIONS: Array<{
  value: ProductBehavior;
  labelKey: BehaviourLabelKey;
}> = [
  { value: ProductBehavior.GOOGLE_REVIEW, labelKey: 'typeGoogleReview' },
  { value: ProductBehavior.INSTAGRAM, labelKey: 'typeInstagram' },
  { value: ProductBehavior.FACEBOOK, labelKey: 'typeFacebook' },
  { value: ProductBehavior.TIKTOK, labelKey: 'typeTiktok' },
  { value: ProductBehavior.MENU, labelKey: 'typeMenu' },
  { value: ProductBehavior.URL, labelKey: 'typeUrl' },
  { value: ProductBehavior.PROFILE, labelKey: 'typeProfile' },
];

/** Product kind (GO, IG, ME, CU, BC) – set at setup from QR param, never editable. */
export const PRODUCT_KIND_OPTIONS: Array<{
  value: LegacyProductCode;
  labelKey: BehaviourLabelKey;
}> = [
  { value: LegacyProductCode.GO, labelKey: 'typeGoogleReview' },
  { value: LegacyProductCode.IG, labelKey: 'typeInstagram' },
  { value: LegacyProductCode.FB, labelKey: 'typeFacebook' },
  { value: LegacyProductCode.TT, labelKey: 'typeTiktok' },
  { value: LegacyProductCode.ME, labelKey: 'typeMenu' },
  { value: LegacyProductCode.CU, labelKey: 'typeUrl' },
  { value: LegacyProductCode.BC, labelKey: 'typeProfile' },
];

/** Target kind (URL, PROFILE, GOOGLE_REVIEW, etc.) – editable only when productType is not known. */
export const TARGET_KIND_OPTIONS: Array<{
  value: ProductBehavior;
  labelKey: BehaviourLabelKey;
}> = [
  { value: ProductBehavior.URL, labelKey: 'typeUrl' },
  { value: ProductBehavior.PROFILE, labelKey: 'typeProfile' },
  { value: ProductBehavior.GOOGLE_REVIEW, labelKey: 'typeGoogleReview' },
  { value: ProductBehavior.INSTAGRAM, labelKey: 'typeInstagram' },
  { value: ProductBehavior.FACEBOOK, labelKey: 'typeFacebook' },
  { value: ProductBehavior.TIKTOK, labelKey: 'typeTiktok' },
  { value: ProductBehavior.MENU, labelKey: 'typeMenu' },
];

const KNOWN_PRODUCT_TYPES: string[] = Object.values(LegacyProductCode);
export function isProductTypeKnown(productType: string | undefined): boolean {
  return !!(
    productType?.trim() && KNOWN_PRODUCT_TYPES.includes(productType.trim())
  );
}
